import { Route } from "react-router-dom";
import { lazy } from "react";
import { PATHS } from "../../../constants/paths";

const DashboardPage = lazy(() => import("../Dashboard"));

const useDashboardRoutes = () => (
  <Route path={PATHS.Dashboard.Path} element={<DashboardPage />} />
);

export { useDashboardRoutes };
